import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom';
import Home from './Home'
import PostJob from './PostJob';
import { useNavigate, useLocation } from 'react-router-dom';
import AllApplications from './AllApplications';
import ManageBlogs from './Blogs';
import Faqs from './Faqs';
import Jobs from './Jobs';
import TalentCommunity from './TalentCommunity';
import ClientReviews from './ClientReviews';

const Dashboard = () => {

    // const handleToggleSharing = () => {
    //     setAllowSharing((prev) => !prev);
    // };




    const [activeSection, setActiveSection] = useState('home');


    const [jobs, setJobs] = useState('');
    const [archivedJobs, setArchivedJobs] = useState([]);

    const [selectedJob, setSelectedJob] = useState(null);
    // console.log(selectedJob)
    const [showPostJobModal, setShowPostJobModal] = useState(false);
    const COLORS = ['#c5baaa', '#806d61', '#ee7828', '#2c2c2c'];







    const Modal = ({ job, onClose }) => (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-md w-96">
                <h3 className="text-xl font-bold mb-4">{job.title}</h3>
                <p>{job.description}</p>
                <button
                    onClick={onClose}
                    className="mt-4 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                >
                    Close
                </button>
            </div>
        </div>
    );






    useEffect(() => {
        const fetchJobs = async () => {
            try {
                const token = localStorage.getItem('accessToken');
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getalljobs`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                setJobs(response.data);
            } catch (error) {
                console.error('Error fetching jobs:', error);
            }
        };

        if (activeSection === 'jobs') {

        }
        fetchJobs();
    }, []);

    useEffect(() => {
        const fetchJobs = async () => {
            try {
                const token = localStorage.getItem('accessToken');
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getarchivedjobs`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                setArchivedJobs(response.data);
            } catch (error) {
                console.error('Error fetching jobs:', error);
            }
        };

        // if (activeSection === 'Archived_Jobs') {


        // }
        fetchJobs();
    }, []);
    // getarchivedjobs




    const [showApplicants, setShowApplicants] = useState({}); // Track applicants for each job
    const [applicants, setApplicants] = useState({}); // 



    useEffect(() => {
        const fetchApplications = async () => {
            try {
                const token = localStorage.getItem('accessToken');
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getallapplications`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                setApplications(response.data);
            } catch (error) {
                console.error('Error fetching jobs:', error);
            }
        };

        fetchApplications();
    }, []);







    const [applications, setApplications] = useState([]);


    const navigate = useNavigate();
    const location = useLocation();

    const changeURL = (sectionName) => {
        navigate(`?section=${sectionName}`);
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const sectionParam = searchParams.get('section');


        // const fetcharchivedJobs = async () => {
        //     try {
        //         const response = await axios.get('http://localhost:5500/jobs/getarchivedjobs');
        //         setArchivedJobs(response.data);
        //     } catch (error) {
        //         console.error('Error fetching jobs:', error);
        //     }
        // };

        // if (activeSection === 'Archived_Jobs') {


        // }
        if (sectionParam) {
            //    if(sectionParam=='Archived_Jobs'){ fetcharchivedJobs();}

            setActiveSection(sectionParam);
        } else {
            setActiveSection('home'); // Default if no section in URL
        }
    }, [location.search]);

    const [isWebsiteMenuOpen, setIsWebsiteMenuOpen] = useState(false);

    const fetchApplicants = async (jobId) => {
        try {
            // Always clear previous applicants before fetching new ones
            setApplicants({ ...applicants, [jobId]: [] });
            const token = localStorage.getItem('accessToken');
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/jobs/getjobapplications?id=${jobId}&paused=true`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            console.log(response.data);
            setApplicants({ ...applicants, [jobId]: response.data });
            setShowApplicants({ ...showApplicants, [jobId]: true });
        } catch (error) {
            console.error('Error fetching applicants:', error);
        }
    };

    const handleUnPause = async (jobId) => {
        try {
            console.log(jobId);
            const token = localStorage.getItem('accessToken');
            // Make the DELETE request with the ID in the request body
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/unpausejob`, {
                id: jobId, // Send the ID in the request body
            }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            // // If the delete request is successful, update the local state
            // setJobs(jobs.filter((job) => job._id !== id)); // Assuming _id is used

            // console.log('Job archived successfully on the server.');
        } catch (error) {
            console.error('Error archiving job:', error);
            // Handle the error (e.g., show an error message to the user)
        }

    };

    const handleSignOut = () => {
        localStorage.removeItem('accessToken');
        navigate('/adminlogin');
    };
    return (
        <div className="flex h-screen">

            <aside className="fixed w-64 bg-[#2c2c2c] text-white p-6 flex flex-col h-screen">
                <h2 className="text-xl font-bold mb-6">Dashboard</h2>
                <nav className="flex flex-col gap-4">
                    <button
                        className={`py-2 px-3 rounded !text-left ${activeSection === 'home' ? 'bg-[#806d61]' : 'hover:bg-[#806d61]'}`}
                        onClick={() => changeURL('home')}
                    >
                        Home
                    </button>
                    <button
                        className={`py-2 px-3 rounded !text-left ${activeSection === 'postJob' ? 'bg-[#806d61]' : 'hover:bg-[#806d61]'}`}
                        onClick={() => changeURL('postJob')}
                    >
                        Post A Job
                    </button>
                    <button
                        className={`py-2 px-3 rounded !text-left ${activeSection === 'jobs' ? 'bg-[#806d61]' : 'hover:bg-[#806d61]'}`}
                        onClick={() => changeURL('jobs')}
                    >
                        Manage All Jobs
                    </button>
                    <button
                        className={`py-2 px-3 rounded !text-left ${activeSection === 'Archived_Jobs' ? 'bg-[#806d61]' : 'hover:bg-[#806d61]'}`}
                        onClick={() => changeURL('Archived_Jobs')}
                    >
                        Paused Jobs
                    </button>
                    <button
                        className={`py-2 px-3 rounded !text-left ${activeSection === 'applications' ? 'bg-[#806d61]' : 'hover:bg-[#806d61]'}`}
                        onClick={() => {
                            changeURL('applications');
                            setApplicants({});
                            setShowApplicants({});
                        }}
                    >
                        All Applications
                    </button>

                    <button
                        className={`py-2 px-3 rounded !text-left ${activeSection === 'talentCommunity' ? 'bg-[#806d61]' : 'hover:bg-[#806d61]'}`}
                        onClick={() => changeURL('talentCommunity')}
                    >
                        Talent Community
                    </button>

                    <div className="flex flex-col">
                        <button
                            className={`py-2 px-3 rounded !text-left flex justify-between items-center ${activeSection === 'Manage_website' ? 'bg-[#806d61]' : 'hover:bg-[#806d61]'}`}
                            onClick={() => {
                                setIsWebsiteMenuOpen(!isWebsiteMenuOpen);
                                // changeURL('Manage_website');
                            }}
                        >
                            Manage Website
                            <span
                                className={`transition-transform duration-200 ${isWebsiteMenuOpen ? 'rotate-180' : 'rotate-0'
                                    }`}
                            >
                                ▼
                            </span>
                        </button>
                        {isWebsiteMenuOpen && (
                            <div className="ml-4 mt-2 flex flex-col gap-2">
                                <button
                                    className={`py-1 px-2 rounded !text-left ${activeSection === 'manage_blogs' ? 'bg-[#806d61]' : 'hover:bg-[#806d61]'}`}
                                    onClick={() => changeURL('manage_blogs')}
                                >
                                    Manage Blogs
                                </button>
                                <button
                                    className={`py-1 px-2 rounded !text-left ${activeSection === 'manage_faqs' ? 'bg-[#806d61]' : 'hover:bg-[#806d61]'}`}
                                    onClick={() => changeURL('manage_faqs')}
                                >
                                    Manage FAQs
                                </button>
                                <button
                                    className={`py-1 px-2 rounded !text-left ${activeSection === 'manage_reviews' ? 'bg-[#806d61]' : 'hover:bg-[#806d61]'}`}
                                    onClick={() => changeURL('manage_reviews')}
                                >
                                    Manage Reviews
                                </button>
                            </div>
                        )}
                    </div>
                </nav>
            </aside>


            {/* Main Content */}
            <main className="flex-1 flex flex-col ml-64 overflow-y-auto">
                {/* Navbar */}
                <header className="navShade p-4 flex justify-between items-center">
                    <h1 className="text-xl font-bold">Admin Dashboard</h1>
                    <button
                        className="bg-[#2c2c2c] text-white px-4 py-2 rounded"
                        onClick={handleSignOut}
                    >
                        Sign Out
                    </button>
                </header>

                {/* Content Area */}
                <div className="flex-1 p-6 w-full max-w-[1100px] mx-auto">




                    {activeSection === 'jobs' && (

                        <Jobs jobs={jobs} showApplicants={showApplicants} applicants={applicants}
                            setApplicants={setApplicants} setShowApplicants={setShowApplicants} setJobs={setJobs} />

                    )}


                    {/* {activeSection === 'Archived_Jobs' && (
                        <div> */}
                    {activeSection === 'Archived_Jobs' && (
                        <div className="grid grid-cols-1 gap-4">
                            <h2 className="text-lg font-bold text-[#2c2c2c]">Paused Jobs</h2>

                            {archivedJobs?.map((job) => (
                                <div key={job._id} className="bg-[#fff] text-black p-4 rounded shadow">
                                    <h3 className="text-lg font-bold">{job.title}</h3>
                                    <p>{job.description}</p>
                                    <div className="mt-4 flex gap-2">
                                        <button
                                            className="bg-[#ee7828] text-white px-4 py-2 rounded hover:bg-[#d86b1f]"
                                            onClick={() => setSelectedJob(job)}
                                        >
                                            View
                                        </button>
                                        <button
                                            className="bg-[#2c2c2c] text-white px-4 py-2 rounded hover:bg-[#1f1f1f]"
                                            onClick={() => handleUnPause(job._id)}
                                        >
                                            Un-Pause
                                        </button>
                                        <button
                                            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                                        // onClick={() => handleDelete(job._id)}
                                        >
                                            Delete
                                        </button>
                                        <button
                                            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                                            onClick={() => fetchApplicants(job._id)}
                                        >
                                            View All Applicants
                                        </button>
                                        <button
                                            className="bg-green-500 text-white px-3 py-1 rounded text-sm"
                                        // onClick={() => downloadInsdividualJobExcel(job)}
                                        >
                                            Download to Excel
                                        </button>
                                    </div>
                                </div>
                            ))}

                            {selectedJob && (
                                <div
                                    className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center overflow-y-auto"
                                    onClick={(e) => {
                                        if (e.target === e.currentTarget) {
                                            setSelectedJob(null);
                                        }
                                    }}
                                >
                                    <div className="bg-white p-4 rounded max-w-lg w-full m-4 overflow-y-auto max-h-[90vh]">
                                        <h2 className="text-2xl font-bold mb-4">{selectedJob.title}</h2>
                                        <p className="mb-2">
                                            <strong>Description:</strong> {selectedJob.description}
                                        </p>
                                        <p className="mb-2">
                                            <strong>Category:</strong> {selectedJob.category}
                                        </p>
                                        <p className="mb-2">
                                            <strong>Location Type:</strong> {selectedJob.locationType}
                                        </p>
                                        {selectedJob.location && (
                                            <p className="mb-2">
                                                <strong>Location:</strong> {selectedJob.location}
                                            </p>
                                        )}
                                        <p className="mb-2">
                                            <strong>Experience Level:</strong> {selectedJob.experienceLevel}
                                        </p>
                                        <p className="mb-2">
                                            <strong>Salary Range:</strong> {selectedJob.salaryRange}
                                        </p>
                                        <p className="mb-2">
                                            <strong>Deadline:</strong> {new Date(selectedJob.deadline).toLocaleDateString()}
                                        </p>
                                        <p className="mb-2">
                                            <strong>Department:</strong> {selectedJob.department}
                                        </p>
                                        <p className="mb-2">
                                            <strong>Responsibilities:</strong> {selectedJob.responsibilities}
                                        </p>
                                        <p className="mb-2">
                                            <strong>Requirements:</strong> {selectedJob.requirements}
                                        </p>
                                        <p className="mb-2">
                                            <strong>Application Link:</strong>{' '}
                                            <a
                                                href={selectedJob.applicationLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {selectedJob.applicationLink}
                                            </a>
                                        </p>
                                        <p className="mb-2">
                                            <strong>Contact Email:</strong> {selectedJob.contactEmail}
                                        </p>
                                        <p className="mb-2">
                                            <strong>Allow Sharing:</strong> {selectedJob.allowSharing ? 'Yes' : 'No'}
                                        </p>

                                        <h3 className="text-lg font-semibold mt-4 mb-2">Questions:</h3>
                                        {selectedJob.questions.map((question) => (
                                            <div key={question.id} className="mb-2">
                                                <p>
                                                    <strong>{question.question}</strong> ({question.type})
                                                </p>
                                                {question.options && question.options.length > 0 && (
                                                    <ul className="list-disc list-inside">
                                                        {question.options.map((option, index) => (
                                                            <li key={index}>{option}</li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        ))}

                                        <button
                                            className="bg-gray-300 px-4 py-2 rounded mt-4"
                                            onClick={() => setSelectedJob(null)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {/* </div>
                    )} */}

                    {activeSection === 'home' && (
                        <Home jobs={jobs} setJobs={setJobs} applications={applications} />

                    )}

                    {activeSection === 'applications' && (
                        <AllApplications applications={applications} />
                    )}

                    {activeSection === 'postJob' && (

                        <PostJob />

                    )}

                    {activeSection === 'manage_blogs' && (
                        <ManageBlogs />
                    )}
                    {activeSection === 'manage_faqs' && (
                        <Faqs />
                    )}

                    {activeSection === 'manage_reviews' &&
                        <ClientReviews />
                    }


                    {activeSection === 'talentCommunity' && (
                        <TalentCommunity />
                    )}

                </div>
            </main>
        </div>
    );
};

export default Dashboard;
